import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=5788fdf7"
import script from "./SearchHeader.vue?vue&type=script&lang=ts"
export * from "./SearchHeader.vue?vue&type=script&lang=ts"
import style0 from "./SearchHeader.vue?vue&type=style&index=0&id=5788fdf7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports